<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "dealers",
    cardSetLink: "dealers",
    item: null,
    fields: [
      {
        label: "Торговые точки на контроле",
        key: "shops",
        labelKey: "shop_on_controls",
        type: "selects",
        modal: "shop",
        selectKey: "name",
      },
      {
        col: " col-12 col-md-12",
        key: "type",
        labelKey: "type_company",
        label: "Тип компании",
        type: "static_radio",
        items: [
          { id: "op", title: "ИП" },
          { id: "llc", title: "ООО" },
        ],
      },
      {
        col: " col-12 col-md-12",
        key: "user",
        labelKey: "employee_owner",
        label: "Отвественный сотрудник",
        type: "select",
        modal: "user",
        selectKey: "phone",
      },
      {
        col: " col-12 col-md-12",
        key: "owner_name",
        labelKey: "contact_name",
        label: "ФИО контактное",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "legal_name",
        labelKey: "legal_name",
        label: "Юридическое название компании",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "trade_name",
        labelKey: "trade_name",
        label: "Торговое название сети",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "name",
        labelKey: "name_company",
        label: "Название компании",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "phone",
        labelKey: "contact_phone",
        label: "Контакнтный номер",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "email",
        labelKey: "email",
        label: "Контакнтный email",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "oked",
        labelKey: "oked",
        label: "ОКЭД компании",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "tin",
        labelKey: "tin_company",
        label: "ИНН компании",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "tax_percent",
        labelKey: "tax_percent",
        label: "Процент НДС",
        type: "field",
        textType: "text",
      },

      {
        col: " col-12 col-md-12",
        key: "activity",
        lableKey: "activity_company",
        label: "Деятельность компании",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "legal_address",
        labelKey: "legal_address",
        label: "Юридический адрес компании",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "founders_count",
        labelKey: "founders_count",
        label: "Количество учредителей",
        type: "field",
        textType: "number",
      },
      {
        col: " col-12 col-md-6",
        key: "foundation_at",
        labelKey: "foundation_at",
        label: "Дата основания компании	",
        type: "field",
        textType: "date",
      },
      {
        col: " col-12 col-md-12",
        key: "secret",
        labelKey: "secret",
        label: "Ключ для получения данных	",
        type: "field",
      },
      {
        col: " col-12 col-md-12",
        key: "status",
        labelKey: "status",
        label: "Статус",
        type: "static_radio",
        items: [
          { id: "new", title: "Новый" },
          { id: "good", title: "Успешный" },
          { id: "bad", title: "Проблемный" },
        ],
      },
      {
        col: " col-12 col-md-12",
        key: "director_name",
        labelKey: "director_name",
        label: "ФИО	директора",
        type: "field",
      },
      {
        col: " col-4",
        key: "director_passport_series",
        labelKey: "director_passport_series",
        label: "Серия паспорта директора",
        type: "field",
      },
      {
        col: " col-8",
        key: "director_passport_id",
        labelKey: "director_passport_id",
        label: "Номер паспорта директора",
        type: "field",
      },
      {
        col: " col-12",
        key: "director_passport_issued_by",
        labelKey: "director_passport_issued_by",
        label: "Кем выдан паспорт директора	",
        type: "field",
      },

      {
        col: " col-12 col-md-12",
        key: "chief_accountant_name",
        labelKey: "chief_accountant_name",
        label: "ФИО  бухгалтера",
        type: "field",
      },
      {
        col: " col-4",
        key: "chief_accountant_passport_series",
        labelKey: "chief_accountant_passport_series",
        label: "Серия паспорта  бухгалтера",
        type: "field",
      },
      {
        col: " col-8",
        key: "chief_accountant_passport_id",
        labelKey: "chief_accountant_passport_id",
        label: "Номер паспорта  бухгалтера",
        type: "field",
      },
      {
        col: " col-12",
        key: "chief_accountant_passport_issued_by",
        labelKey: "chief_accountant_passport_issued_by",
        label: "Кем выдан паспорт  бухгалтера",
        type: "field",
      },

      {
        col: " col-12",
        key: "bank_name",
        labelKey: "bank_name",
        label: "Название банка",
        type: "field",
      },
      {
        col: " col-12",
        key: "bank_account",
        labelKey: "bank_account",
        label: "Расчётный счёт",
        type: "field",
      },
      {
        col: " col-12 col-md-6",
        key: "bank_tin",
        labelKey: "bank_tin",
        label: "ИНН банка	",
        type: "field",
      },
      {
        col: " col-12 col-md-6",
        key: "bank_mfo",
        labelKey: "bank_mfo",
        label: "МФО банка",
        type: "field",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
